import { Margin, usePDF } from "react-to-pdf";
import SurveyJsPanel from "../SurveyJsPanel";
import { Box, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { axiosInstance } from "../../../../utils/networking";

const InitialContactReport = () => {
  const [cities, setCities] = useState<string[]>([]);
  const [data1, setData1] = useState<any[]>([]);
  useEffect(() => {
    axiosInstance.get(`/reports/initial_contact`).then((response: any) => {
      setCities(response.data.cities);
      setData1(response.data.firmsWithInitialContact);
    });
  }, []);

  const surveyContent1 = {
    elements: [
      {
        name: "City",
        title: "Initial Contact made by community/city",
        type: "dropdown",
        choices: cities,
      },
    ],
    showQuestionNumbers: "off",
    completedHtml: "Thank you for your feedback!",
  };

  const surveyResult1: any[] = data1;

  const { toPDF, targetRef } = usePDF({
    filename: "Report.pdf",
    page: { margin: Margin.SMALL, format: "letter" },
    overrides: {
      canvas: {
        removeContainer: false,
      },
    },
  });

  return (
    <>
      <Box sx={{ position: "absolute", marginTop: "-42px" }}>
        <Button
          sx={{ marginLeft: "10px" }}
          color={"warning"}
          variant="contained"
          onClick={() => {
            toPDF();
            axiosInstance.post("/export_log", {
              export_type: "report_pdf",
              record_count: data1.length,
              filters: { report: "InitialContact" },
            });
          }}
        >
          Print
        </Button>
      </Box>
      <SurveyJsPanel
        surveyTitle={"Initial Contact Report"}
        pdfref={targetRef}
        surveyContent={surveyContent1}
        surveyResult={surveyResult1}
      ></SurveyJsPanel>
    </>
  );
};

export default InitialContactReport;
